if (!customElements.get('mobile-sticky-add-to-cart')) {
  customElements.define(
    'mobile-sticky-add-to-cart',
    class MobileStickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.stickyButton = this.querySelector('[data-mobile-sticky-atc-button]');
        this.productForm = this.parentElement?.querySelector('product-form');
        this.sourceButton = this.productForm?.querySelector('.product-form__submit');

        if (!this.stickyButton || !this.productForm || !this.sourceButton) return;

        this.portal = document.createElement('div');
        this.portal.className = 'mobile-sticky-add-to-cart';
        this.portal.dataset.sectionId = this.dataset.sectionId || '';
        this.portal.appendChild(this.stickyButton);
        document.body.appendChild(this.portal);

        this.handleClick = this.handleClick.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.stickyButton.addEventListener('click', this.handleClick);
        this.mobileQuery.addEventListener('change', this.handleViewportChange);

        this.sourceButtonObserver = new MutationObserver(() => this.syncButtonState());
        this.sourceButtonObserver.observe(this.sourceButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
        });

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const viewportTopBoundary = entry.rootBounds?.top ?? window.innerHeight * 0.15;
            this.sourceButtonHasBeenPassed = entry.boundingClientRect.bottom <= viewportTopBoundary;
            this.updateVisibility();
          },
          { rootMargin: '-15% 0px -15% 0px', threshold: 0 }
        );
        const sourceButtonRect = this.sourceButton.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        this.sourceButtonHasBeenPassed = sourceButtonRect.bottom <= viewportHeight * 0.15;
        this.visibilityObserver.observe(this.sourceButton);

        this.syncButtonState();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleClick);
        this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
        this.sourceButtonObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.portal?.remove();
      }

      handleViewportChange() {
        this.updateVisibility();
      }

      updateVisibility() {
        const shouldShow = this.mobileQuery?.matches && this.sourceButtonHasBeenPassed;
        this.portal?.classList.toggle('is-visible', Boolean(shouldShow));
        this.portal?.setAttribute('aria-hidden', String(!shouldShow));
      }

      syncButtonState() {
        const disabled =
          this.sourceButton.disabled ||
          this.sourceButton.getAttribute('aria-disabled') === 'true' ||
          this.sourceButton.classList.contains('loading');

        this.stickyButton.disabled = disabled;
        this.stickyButton.setAttribute('aria-disabled', String(disabled));
        this.portal?.classList.toggle('is-loading', this.sourceButton.classList.contains('loading'));
      }

      getFirstMissingPersonalizationInput() {
        return Array.from(
          this.productForm.querySelectorAll(
            '[data-product-personalization]:not([hidden]) [data-product-personalization-input][required]:not(:disabled)'
          )
        ).find((input) => !input.value.trim());
      }

      handleClick() {
        const missingInput = this.getFirstMissingPersonalizationInput();

        if (missingInput) {
          const field = missingInput.closest('[data-product-personalization-field]');
          field?.classList.add('has-validation-error');
          missingInput.addEventListener('input', () => field?.classList.remove('has-validation-error'), { once: true });

          (missingInput.closest('[data-product-personalization]') || missingInput).scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center',
          });

          window.setTimeout(() => {
            missingInput.focus({ preventScroll: true });
            missingInput.reportValidity();
          }, 260);
          return;
        }

        this.sourceButton.click();
      }
    }
  );
}
